'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _MDIcon = require('./MDIcon')

var _MDIcon2 = _interopRequireDefault(_MDIcon)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _objectWithoutProperties(obj, keys) {
  var target = {}
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
    target[i] = obj[i]
  }
  return target
}

var Icon = function Icon(_ref) {
  var set = _ref.set,
    props = _objectWithoutProperties(_ref, ['set'])

  var Component = {
    md: _MDIcon2.default
  }[set]
  return _react2.default.createElement(Component, props)
}

Icon.displayName = 'Icon'

Icon.propTypes = {
  set: _propTypes2.default.oneOf(['md'])
}

Icon.defaultProps = {
  set: 'md'
}

exports.default = Icon



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Icon.js
// module id = 25
// module chunks = 35783957827783 95816961762493 114276838955818 231178572073751